<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'App'
}
</script>

<style>
#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;    
	}

.parent {
	display: flex;
	background: url("/static/fundo_rsui.png")fixed no-repeat;
	-webkit-background-size: 100% 100%;
	-o-background-size: 100% 100%;
	-moz-background-size: 100% 100%;
	background-size: 100% 100%;
	min-height:100%;
}

body {
	display: flex;
	justify-content: center;
	background: url("/static/fundo_rsui.png")fixed no-repeat;
	-webkit-background-size: 100% 100%;
	-o-background-size: 100% 100%;
	-moz-background-size: 100% 100%;
	background-size: 100% 100%;
	min-height:100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue